import { render, staticRenderFns } from "./ModelCubes.vue?vue&type=template&id=17605a6c"
import script from "./ModelCubes.vue?vue&type=script&lang=ts"
export * from "./ModelCubes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports